module.exports = __webpack_public_path__ + "img/Training-Development-t-19217-s001.3466de02.jpg";